// // import React, { useEffect, useMemo, useState } from "react";
// // import { X, ChevronLeft, Download, FileText } from "lucide-react";
// // import * as XLSX from "xlsx"; 
// // import Mark from "mark.js"; 
// // import { renderAsync } from "docx-preview"; 

// // function getExt(url = "") {
// //   try {
// //     const u = new URL(url);
// //     const path = u.pathname.toLowerCase();
// //     const m = path.match(/\.([a-z0-9]+)$/);
// //     return m?.[1] || "";
// //   } catch {
// //     const clean = url.split("#")[0].split("?")[0].toLowerCase();
// //     const m = clean.match(/\.([a-z0-9]+)$/);
// //     return m?.[1] || "";
// //   }
// // }

// // // Helper: Clean source text from both APIs
// // function cleanSourceText(rawText) {
// //     if (!rawText) return "";
    
// //     return rawText
// //       // Replace literal "\n" and "\t" strings from JSON with spaces
// //       .replace(/\\[nt]/g, " ")
// //       // Replace actual newlines and tabs with spaces
// //       .replace(/[\n\t]/g, " ")
// //       // Remove ellipses and markdown/bullet characters
// //       .replace(/\.\.\./g, " ")
// //       .replace(/[•●○■*`#_]/g, " ")
// //       // Replace multiple spaces with single space
// //       .replace(/\s+/g, " ")
// //       .trim();
// //   }
  
// //   function buildPdfUrl(rawUrl, { page, highlightText }) {
// //     let url = rawUrl;
// //     const fragments = [];
    
// //     if (page) {
// //       fragments.push(`page=${page}`);
// //     }
    
// //     if (highlightText) {
// //       // 1. Clean the text thoroughly
// //       const cleanText = cleanSourceText(highlightText);
      
// //       // 2. We need a SHORT, EXACT phrase. The native PDF viewer fails on long strings.
// //       // We split into words, remove tiny words (like "a", "an", "the"), and grab 3-4 words.
// //       const words = cleanText.split(" ").filter(w => w.length > 3);
      
// //       let searchTerm = "";
      
// //       if (words.length >= 4) {
// //         // Best case: Grab 4 substantial words to form a highly unique fingerprint
// //         searchTerm = `${words[0]} ${words[1]} ${words[2]} ${words[3]}`;
// //       } else if (words.length >= 2) {
// //         // Fallback 1: 2-3 words
// //         searchTerm = words.slice(0, words.length).join(" ");
// //       } else if (words.length === 1) {
// //         // Fallback 2: Single word
// //         searchTerm = words[0];
// //       } else {
// //         // Ultimate fallback: first 25 characters
// //         searchTerm = cleanText.substring(0, 25);
// //       }
      
// //       // 3. Add search parameter. Do NOT use quotes around it for native Chrome/Edge, 
// //       // it actually prefers URL encoded plain strings for the search parameter.
// //       if (searchTerm) {
// //         fragments.push(`search=${encodeURIComponent(searchTerm)}`);
// //       }
// //     }
  
// //     // PDF parameters MUST be combined with & and preceded by a single #
// //     if (fragments.length > 0) {
// //       url += `#${fragments.join("&")}`;
// //     }
    
// //     return url;
// //   }
  

// // // --- DOCX Viewer using docx-preview for High Fidelity ---
// // function DocxViewer({ url, highlightText }) {
// //   const [isRendered, setIsRendered] = useState(false);
// //   const [err, setErr] = useState("");
// //   const containerRef = React.useRef(null);

// //   useEffect(() => {
// //     if (!url || !containerRef.current) return;
// //     let alive = true;

// //     fetch(url)
// //       .then((r) => {
// //         if (!r.ok) throw new Error(`HTTP ${r.status}`);
// //         return r.blob(); 
// //       })
// //       .then((blob) => {
// //         if (!alive) return;
// //         return renderAsync(blob, containerRef.current, null, {
// //           className: "docx",
// //           inWrapper: true, 
// //           ignoreWidth: false,
// //           ignoreHeight: false,
// //           ignoreFonts: false,
// //           breakPages: true, 
// //           experimental: false,
// //         });
// //       })
// //       .then(() => {
// //         if (!alive) return;
// //         setIsRendered(true); 
// //         setErr("");
// //       })
// //       .catch((e) => {
// //         if (!alive) return;
// //         setErr(e.message || "Failed to load DOCX");
// //       });

// //     return () => {
// //       alive = false;
// //     };
// //   }, [url]);

// //   useEffect(() => {
// //     // Clean the highlight text for Mark.js
// //     const cleanHighlight = cleanSourceText(highlightText);
// //     if (!isRendered || !cleanHighlight || !containerRef.current) return;

// //     const markInstance = new Mark(containerRef.current);
// //     markInstance.mark(cleanHighlight, {
// //       element: "mark",
// //       className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900 shadow-sm",
// //       accuracy: "partially",
// //       separateWordSearch: false,
// //       acrossElements: true, 
// //       done: (totalMatches) => {
// //         if (totalMatches > 0) {
// //           setTimeout(() => {
// //             const firstMark = containerRef.current.querySelector("mark");
// //             if (firstMark) {
// //               firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
// //             }
// //           }, 200);
// //         }
// //       }
// //     });

// //     return () => markInstance.unmark();
// //   }, [isRendered, highlightText]);

// //   if (err) return <div className="p-4 text-sm text-red-600 font-medium">DOCX error: {err}</div>;
  
// //   return (
// //     <div className="h-full overflow-auto bg-gray-200 p-4 relative">
// //       {!isRendered && (
// //         <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
// //           <span className="text-sm text-gray-500 animate-pulse">Loading Document Layout…</span>
// //         </div>
// //       )}
// //       <div 
// //         ref={containerRef} 
// //         className="mx-auto" 
// //         style={{ width: "fit-content" }}
// //       />
// //     </div>
// //   );
// // }

// // // Excel renderer with highlighting and auto-scroll
// // function ExcelViewer({ url, highlightText }) {
// //   const [html, setHtml] = useState("");
// //   const [err, setErr] = useState("");
// //   const containerRef = React.useRef(null);
  
// //   useEffect(() => {
// //     if (!url) return;
// //     let alive = true;
  
// //     fetch(url)
// //       .then((r) => {
// //         if (!r.ok) throw new Error(`HTTP ${r.status}`);
// //         return r.arrayBuffer();
// //       })
// //       .then((buffer) => {
// //         if (!alive) return;
// //         const wb = XLSX.read(buffer, { type: "array" });
// //         const firstSheet = wb.Sheets[wb.SheetNames[0]];
// //         const htmlStr = XLSX.utils.sheet_to_html(firstSheet, { header: "", footer: "" });
          
// //         const parser = new DOMParser();
// //         const doc = parser.parseFromString(htmlStr, "text/html");
// //         const table = doc.querySelector("table");
          
// //         if (table) {
// //           table.className = "w-full text-left border-collapse text-sm font-outfit";
            
// //           const rows = table.querySelectorAll("tr");
// //           rows.forEach((tr, index) => {
// //             tr.className = "border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150 ease-in-out group";
// //             if (index === 0) tr.classList.add("bg-gray-50", "font-medium", "text-gray-900");
// //           });
  
// //           const cells = table.querySelectorAll("td, th");
// //           cells.forEach((td) => {
// //             td.className = "px-4 py-3 border-r border-gray-200 last:border-r-0 text-gray-700 whitespace-pre-wrap break-words align-top leading-relaxed tracking-wide";
// //             if (!td.textContent.trim()) td.innerHTML = "&nbsp;";
// //           });
  
// //           setHtml(table.outerHTML);
// //         } else {
// //           setHtml(htmlStr);
// //         }
// //         setErr("");
// //       })
// //       .catch((e) => {
// //         if (!alive) return;
// //         setErr(e.message || "Failed to load Excel");
// //       });
  
// //     return () => {
// //       alive = false;
// //     };
// //   }, [url]);
  
// //   useEffect(() => {
// //     const cleanHighlight = cleanSourceText(highlightText);
// //     if (!html || !cleanHighlight || !containerRef.current) return;
  
// //     const markInstance = new Mark(containerRef.current);
// //     markInstance.mark(cleanHighlight, {
// //       element: "mark",
// //       className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900",
// //       accuracy: "partially",
// //       separateWordSearch: false,
// //       done: (totalMatches) => {
// //         if (totalMatches > 0) {
// //           setTimeout(() => {
// //             const firstMark = containerRef.current.querySelector("mark");
// //             if (firstMark) {
// //               firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
// //             }
// //           }, 100);
// //         }
// //       }
// //     });
  
// //     return () => markInstance.unmark();
// //   }, [html, highlightText]);
  
// //   if (err) return <div className="p-4 text-sm text-red-600 font-medium">Excel error: {err}</div>;
// //   if (!html) return <div className="p-4 text-sm text-gray-500 animate-pulse">Loading Excel…</div>;
  
// //   return (
// //     <div
// //       ref={containerRef}
// //       className="p-6 h-full overflow-auto bg-white"
// //       dangerouslySetInnerHTML={{ __html: html }}
// //     />
// //   );
// // }
  
// // // CSV renderer with highlighting
// // function CsvViewer({ url, highlightText }) {
// //   const [text, setText] = useState("");
// //   const [err, setErr] = useState("");
// //   const containerRef = React.useRef(null);

// //   useEffect(() => {
// //     if (!url) return;
// //     let alive = true;

// //     fetch(url)
// //       .then((r) => {
// //         if (!r.ok) throw new Error(`HTTP ${r.status}`);
// //         return r.text();
// //       })
// //       .then((t) => {
// //         if (!alive) return;
// //         setText(t);
// //         setErr("");
// //       })
// //       .catch((e) => {
// //         if (!alive) return;
// //         setErr(e.message || "Failed to load CSV");
// //       });

// //     return () => {
// //       alive = false;
// //     };
// //   }, [url]);

// //   useEffect(() => {
// //     const cleanHighlight = cleanSourceText(highlightText);
// //     if (!text || !cleanHighlight || !containerRef.current) return;

// //     const markInstance = new Mark(containerRef.current);
// //     markInstance.mark(cleanHighlight, {
// //       element: "mark",
// //       className: "bg-yellow-300",
// //       accuracy: "partially",
// //       separateWordSearch: false,
// //     });

// //     return () => markInstance.unmark();
// //   }, [text, highlightText]);

// //   if (err) return <div className="p-4 text-sm text-red-600">CSV error: {err}</div>;
// //   if (!text) return <div className="p-4 text-sm text-gray-500">Loading CSV…</div>;

// //   return (
// //     <div ref={containerRef} className="p-3 h-full overflow-auto bg-white">
// //       <pre className="text-xs whitespace-pre-wrap break-words text-gray-800">{text}</pre>
// //     </div>
// //   );
// // }

// // function buildViewer({ url, ext, page, highlightText }) {
// //   if (!url) return { kind: "none", src: "" };

// //   if (ext === "pdf") {
// //     return { kind: "iframe", src: buildPdfUrl(url, { page, highlightText }) };
// //   }

// //   if (["xls", "xlsx"].includes(ext)) {
// //     return { kind: "excel", src: url };
// //   }

// //   if (ext === "csv") {
// //     return { kind: "csv", src: url };
// //   }

// //   if (ext === "docx") {
// //     return { kind: "docx", src: url };
// //   }

// //   if (["doc", "ppt", "pptx"].includes(ext)) {
// //     const officeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
// //       url
// //     )}`;
// //     return { kind: "iframe", src: officeSrc };
// //   }

// //   return { kind: "iframe", src: url };
// // }

// // // Helper to format the displayed text cleanly in the UI card
// // function cleanSnippetForDisplay(rawText) {
// //   if (!rawText) return "";
// //   return rawText
// //     .replace(/\\n/g, "\n")
// //     .replace(/\\t/g, " ")
// //     .replace(/\.\.\./g, "")
// //     .replace(/[\u200B-\u200D\uFEFF]/g, "")
// //     .trim();
// // }

// // const SourceViewModal = ({ isOpen, onClose, data }) => {
// //   const [isVisible, setIsVisible] = useState(false);

// //   useEffect(() => {
// //     if (isOpen) {
// //       setIsVisible(true);
// //       document.body.style.overflow = "hidden";
// //     } else {
// //       const timer = setTimeout(() => setIsVisible(false), 300);
// //       document.body.style.overflow = "unset";
// //       return () => clearTimeout(timer);
// //     }
// //   }, [isOpen]);

// //   const rawUrl = data?.document_url || data?.url || "";
// //   const ext = useMemo(() => getExt(rawUrl), [rawUrl]);
// //   const highlightText = data?.source_text || data?.highlightText || "";
// //   const pageNum = data?.page_number || data?.page || "";
// //   const docName = data?.document_name || data?.name || "Document Viewer";

// //   const viewer = useMemo(
// //     () =>
// //       buildViewer({
// //         url: rawUrl,
// //         ext,
// //         page: pageNum,
// //         highlightText: highlightText,
// //       }),
// //     [rawUrl, ext, pageNum, highlightText]
// //   );

// //   if (!isVisible && !isOpen) return null;

// //   // Show highlight card for PDFs
// //   const showHighlightCard = highlightText && !["xlsx", "xls", "csv", "docx"].includes(ext);

// //   // Clean display for the UI card
// //   const displayHighlight = cleanSnippetForDisplay(highlightText);

// //   return (
// //     <div className="fixed inset-0 z-[9999] flex justify-end font-outfit">
// //       <div
// //         className={`absolute inset-0 bg-black/30 transition-opacity duration-300 ease-in-out ${
// //           isOpen ? "opacity-100" : "opacity-0"
// //         }`}
// //         onClick={onClose}
// //       />

// //       <div
// //         className={`relative w-full lg:w-[55%] h-full bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${
// //           isOpen ? "translate-x-0" : "translate-x-full"
// //         }`}
// //       >
// //         <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white shadow-sm z-20 relative">
// //           <div className="flex items-center gap-3 overflow-hidden">
// //             <button
// //               onClick={onClose}
// //               className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
// //             >
// //               <ChevronLeft className="w-5 h-5" />
// //             </button>

// //             <div className="flex flex-col overflow-hidden">
// //               <h3 className="text-sm font-semibold text-gray-900 truncate" title={docName}>
// //                 {docName}
// //               </h3>
// //               <span className="text-xs text-gray-500">
// //                 {ext ? ext.toUpperCase() : "FILE"}
// //                 {pageNum ? ` • Page ${pageNum}` : ""}
// //               </span>
// //             </div>
// //           </div>

// //           <div className="flex items-center gap-2">
// //             {rawUrl && (
// //               <a
// //                 href={rawUrl}
// //                 target="_blank"
// //                 rel="noreferrer"
// //                 className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
// //                 title="Download"
// //               >
// //                 <Download className="w-5 h-5" />
// //               </a>
// //             )}
// //             <button
// //               onClick={onClose}
// //               className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400"
// //             >
// //               <X className="w-5 h-5" />
// //             </button>
// //           </div>
// //         </div>

// //         <div className="flex-1 bg-gray-100 relative overflow-hidden flex flex-col">
         

// //           <div className="flex-1 relative w-full h-full">
// //             {!rawUrl ? (
// //               <div className="flex items-center justify-center h-full text-gray-400">
// //                 No document URL provided
// //               </div>
// //             ) : viewer.kind === "excel" ? (
// //               <ExcelViewer url={viewer.src} highlightText={highlightText} />
// //             ) : viewer.kind === "csv" ? (
// //               <CsvViewer url={viewer.src} highlightText={highlightText} />
// //             ) : viewer.kind === "docx" ? (
// //               <DocxViewer url={viewer.src} highlightText={highlightText} />
// //             ) : (
// //               <iframe 
// //                 src={viewer.src} 
// //                 className="w-full h-full border-none bg-white" 
// //                 title="Document Viewer" 
// //               />
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SourceViewModal;
// import React, { useEffect, useMemo, useState } from "react";
// import { X, ChevronLeft, Download, FileText } from "lucide-react";
// import * as XLSX from "xlsx"; 
// import Mark from "mark.js"; 
// import { renderAsync } from "docx-preview"; 

// function getExt(url = "") {
//   try {
//     const u = new URL(url);
//     const path = u.pathname.toLowerCase();
//     const m = path.match(/\.([a-z0-9]+)$/);
//     return m?.[1] || "";
//   } catch {
//     const clean = url.split("#")[0].split("?")[0].toLowerCase();
//     const m = clean.match(/\.([a-z0-9]+)$/);
//     return m?.[1] || "";
//   }
// }

// // Helper: Clean source text from both APIs
// function cleanSourceText(rawText) {
//     if (!rawText) return "";
    
//     return rawText
//       // Replace literal "\n" and "\t" strings from JSON with spaces
//       .replace(/\\[nt]/g, " ")
//       // Replace actual newlines and tabs with spaces
//       .replace(/[\n\t]/g, " ")
//       // Remove ellipses and markdown/bullet characters
//       .replace(/\.\.\./g, " ")
//       .replace(/[•●○■*`#_]/g, " ")
//       // Replace multiple spaces with single space
//       .replace(/\s+/g, " ")
//       .trim();
//   }
  
//   function buildPdfUrl(rawUrl, { page, highlightText }) {
//     let url = rawUrl;
//     const fragments = [];
    
//     if (page !== undefined && page !== null && page !== "") {
//       fragments.push(`page=${page}`);
//     }
    
//     if (highlightText) {
//       // 1. Clean the text thoroughly
//       const cleanText = cleanSourceText(highlightText);
      
//       // 2. We need a SHORT, EXACT phrase. The native PDF viewer fails on long strings.
//       // We split into words, remove tiny words (like "a", "an", "the"), and grab 3-4 words.
//       const words = cleanText.split(" ").filter(w => w.length > 3);
      
//       let searchTerm = "";
      
//       if (words.length >= 4) {
//         // Best case: Grab 4 substantial words to form a highly unique fingerprint
//         searchTerm = `${words[0]} ${words[1]} ${words[2]} ${words[3]}`;
//       } else if (words.length >= 2) {
//         // Fallback 1: 2-3 words
//         searchTerm = words.slice(0, words.length).join(" ");
//       } else if (words.length === 1) {
//         // Fallback 2: Single word
//         searchTerm = words[0];
//       } else {
//         // Ultimate fallback: first 25 characters
//         searchTerm = cleanText.substring(0, 25);
//       }
      
//       // 3. Add search parameter. Do NOT use quotes around it for native Chrome/Edge, 
//       // it actually prefers URL encoded plain strings for the search parameter.
//       if (searchTerm) {
//         fragments.push(`search=${encodeURIComponent(searchTerm)}`);
//       }
//     }
  
//     // PDF parameters MUST be combined with & and preceded by a single #
//     if (fragments.length > 0) {
//       url += `#${fragments.join("&")}`;
//     }
    
//     return url;
//   }
  
// // --- DOCX Viewer using docx-preview for High Fidelity ---
// function DocxViewer({ url, highlightText }) {
//   const [isRendered, setIsRendered] = useState(false);
//   const [err, setErr] = useState("");
//   const containerRef = React.useRef(null);

//   useEffect(() => {
//     if (!url || !containerRef.current) return;
//     let alive = true;

//     fetch(url)
//       .then((r) => {
//         if (!r.ok) throw new Error(`HTTP ${r.status}`);
//         return r.blob(); 
//       })
//       .then((blob) => {
//         if (!alive) return;
//         return renderAsync(blob, containerRef.current, null, {
//           className: "docx",
//           inWrapper: true, 
//           ignoreWidth: false,
//           ignoreHeight: false,
//           ignoreFonts: false,
//           breakPages: true, 
//           experimental: false,
//         });
//       })
//       .then(() => {
//         if (!alive) return;
//         setIsRendered(true); 
//         setErr("");
//       })
//       .catch((e) => {
//         if (!alive) return;
//         setErr(e.message || "Failed to load DOCX");
//       });

//     return () => {
//       alive = false;
//     };
//   }, [url]);

//   useEffect(() => {
//     // Clean the highlight text for Mark.js
//     const cleanHighlight = cleanSourceText(highlightText);
//     if (!isRendered || !cleanHighlight || !containerRef.current) return;

//     const markInstance = new Mark(containerRef.current);
//     markInstance.mark(cleanHighlight, {
//       element: "mark",
//       className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900 shadow-sm",
//       accuracy: "partially",
//       separateWordSearch: false,
//       acrossElements: true, 
//       done: (totalMatches) => {
//         if (totalMatches > 0) {
//           setTimeout(() => {
//             const firstMark = containerRef.current.querySelector("mark");
//             if (firstMark) {
//               firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
//             }
//           }, 200);
//         }
//       }
//     });

//     return () => markInstance.unmark();
//   }, [isRendered, highlightText]);

//   if (err) return <div className="p-4 text-sm text-red-600 font-medium">DOCX error: {err}</div>;
  
//   return (
//     <div className="h-full overflow-auto bg-gray-200 p-4 relative">
//       {!isRendered && (
//         <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
//           <span className="text-sm text-gray-500 animate-pulse">Loading Document Layout…</span>
//         </div>
//       )}
//       <div 
//         ref={containerRef} 
//         className="mx-auto" 
//         style={{ width: "fit-content" }}
//       />
//     </div>
//   );
// }

// // Excel renderer with highlighting and auto-scroll
// function ExcelViewer({ url, highlightText }) {
//   const [html, setHtml] = useState("");
//   const [err, setErr] = useState("");
//   const containerRef = React.useRef(null);
  
//   useEffect(() => {
//     if (!url) return;
//     let alive = true;
  
//     fetch(url)
//       .then((r) => {
//         if (!r.ok) throw new Error(`HTTP ${r.status}`);
//         return r.arrayBuffer();
//       })
//       .then((buffer) => {
//         if (!alive) return;
//         const wb = XLSX.read(buffer, { type: "array" });
//         const firstSheet = wb.Sheets[wb.SheetNames[0]];
//         const htmlStr = XLSX.utils.sheet_to_html(firstSheet, { header: "", footer: "" });
          
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(htmlStr, "text/html");
//         const table = doc.querySelector("table");
          
//         if (table) {
//           table.className = "w-full text-left border-collapse text-sm font-outfit";
            
//           const rows = table.querySelectorAll("tr");
//           rows.forEach((tr, index) => {
//             tr.className = "border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150 ease-in-out group";
//             if (index === 0) tr.classList.add("bg-gray-50", "font-medium", "text-gray-900");
//           });
  
//           const cells = table.querySelectorAll("td, th");
//           cells.forEach((td) => {
//             td.className = "px-4 py-3 border-r border-gray-200 last:border-r-0 text-gray-700 whitespace-pre-wrap break-words align-top leading-relaxed tracking-wide";
//             if (!td.textContent.trim()) td.innerHTML = "&nbsp;";
//           });
  
//           setHtml(table.outerHTML);
//         } else {
//           setHtml(htmlStr);
//         }
//         setErr("");
//       })
//       .catch((e) => {
//         if (!alive) return;
//         setErr(e.message || "Failed to load Excel");
//       });
  
//     return () => {
//       alive = false;
//     };
//   }, [url]);
  
//   useEffect(() => {
//     const cleanHighlight = cleanSourceText(highlightText);
//     if (!html || !cleanHighlight || !containerRef.current) return;
  
//     const markInstance = new Mark(containerRef.current);
//     markInstance.mark(cleanHighlight, {
//       element: "mark",
//       className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900",
//       accuracy: "partially",
//       separateWordSearch: false,
//       done: (totalMatches) => {
//         if (totalMatches > 0) {
//           setTimeout(() => {
//             const firstMark = containerRef.current.querySelector("mark");
//             if (firstMark) {
//               firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
//             }
//           }, 100);
//         }
//       }
//     });
  
//     return () => markInstance.unmark();
//   }, [html, highlightText]);
  
//   if (err) return <div className="p-4 text-sm text-red-600 font-medium">Excel error: {err}</div>;
//   if (!html) return <div className="p-4 text-sm text-gray-500 animate-pulse">Loading Excel…</div>;
  
//   return (
//     <div
//       ref={containerRef}
//       className="p-6 h-full overflow-auto bg-white"
//       dangerouslySetInnerHTML={{ __html: html }}
//     />
//   );
// }
  
// // CSV renderer with highlighting
// function CsvViewer({ url, highlightText }) {
//   const [text, setText] = useState("");
//   const [err, setErr] = useState("");
//   const containerRef = React.useRef(null);

//   useEffect(() => {
//     if (!url) return;
//     let alive = true;

//     fetch(url)
//       .then((r) => {
//         if (!r.ok) throw new Error(`HTTP ${r.status}`);
//         return r.text();
//       })
//       .then((t) => {
//         if (!alive) return;
//         setText(t);
//         setErr("");
//       })
//       .catch((e) => {
//         if (!alive) return;
//         setErr(e.message || "Failed to load CSV");
//       });

//     return () => {
//       alive = false;
//     };
//   }, [url]);

//   useEffect(() => {
//     const cleanHighlight = cleanSourceText(highlightText);
//     if (!text || !cleanHighlight || !containerRef.current) return;

//     const markInstance = new Mark(containerRef.current);
//     markInstance.mark(cleanHighlight, {
//       element: "mark",
//       className: "bg-yellow-300",
//       accuracy: "partially",
//       separateWordSearch: false,
//     });

//     return () => markInstance.unmark();
//   }, [text, highlightText]);

//   if (err) return <div className="p-4 text-sm text-red-600">CSV error: {err}</div>;
//   if (!text) return <div className="p-4 text-sm text-gray-500">Loading CSV…</div>;

//   return (
//     <div ref={containerRef} className="p-3 h-full overflow-auto bg-white">
//       <pre className="text-xs whitespace-pre-wrap break-words text-gray-800">{text}</pre>
//     </div>
//   );
// }

// function buildViewer({ url, ext, page, highlightText }) {
//   if (!url) return { kind: "none", src: "" };

//   if (ext === "pdf") {
//     return { kind: "iframe", src: buildPdfUrl(url, { page, highlightText }) };
//   }

//   if (["xls", "xlsx"].includes(ext)) {
//     return { kind: "excel", src: url };
//   }

//   if (ext === "csv") {
//     return { kind: "csv", src: url };
//   }

//   if (ext === "docx") {
//     return { kind: "docx", src: url };
//   }

//   if (["doc", "ppt", "pptx"].includes(ext)) {
//     const officeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       url
//     )}`;
//     return { kind: "iframe", src: officeSrc };
//   }

//   return { kind: "iframe", src: url };
// }

// // Helper to format the displayed text cleanly in the UI card
// function cleanSnippetForDisplay(rawText) {
//   if (!rawText) return "";
//   return rawText
//     .replace(/\\n/g, "\n")
//     .replace(/\\t/g, " ")
//     .replace(/\.\.\./g, "")
//     .replace(/[\u200B-\u200D\uFEFF]/g, "")
//     .trim();
// }

// const SourceViewModal = ({ isOpen, onClose, data }) => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       setIsVisible(true);
//       document.body.style.overflow = "hidden";
//     } else {
//       const timer = setTimeout(() => setIsVisible(false), 300);
//       document.body.style.overflow = "unset";
//       return () => clearTimeout(timer);
//     }
//   }, [isOpen]);

//   const rawUrl = data?.document_url || data?.file_url || data?.url || "";
//   const ext = useMemo(() => getExt(rawUrl), [rawUrl]);
//   const highlightText = data?.source_chunk || data?.source_text || data?.highlightText || "";
  
//   // Explicit check for undefined vs 0
//   const pageNum = data?.page_number !== undefined ? data.page_number : (data?.page !== undefined ? data.page : "");
//   const docName = data?.document_name || data?.file_name || data?.name || "Document Viewer";

//   const viewer = useMemo(
//     () =>
//       buildViewer({
//         url: rawUrl,
//         ext,
//         page: pageNum,
//         highlightText: highlightText,
//       }),
//     [rawUrl, ext, pageNum, highlightText]
//   );

//   if (!isVisible && !isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-[9999] flex justify-end font-outfit">
//       <div
//         className={`absolute inset-0 bg-black/30 transition-opacity duration-300 ease-in-out ${
//           isOpen ? "opacity-100" : "opacity-0"
//         }`}
//         onClick={onClose}
//       />

//       <div
//         className={`relative w-full lg:w-[55%] h-full bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${
//           isOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//       >
//         <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white shadow-sm z-20 relative">
//           <div className="flex items-center gap-3 overflow-hidden">
//             <button
//               onClick={onClose}
//               className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
//             >
//               <ChevronLeft className="w-5 h-5" />
//             </button>

//             <div className="flex flex-col overflow-hidden">
//               <h3 className="text-sm font-semibold text-gray-900 truncate" title={docName}>
//                 {docName}
//               </h3>
//               <span className="text-xs text-gray-500">
//                 {ext ? ext.toUpperCase() : "FILE"}
//                 {pageNum !== "" && pageNum !== null && pageNum !== undefined ? ` • Page ${pageNum}` : ""}
//               </span>
//             </div>
//           </div>

//           <div className="flex items-center gap-2">
//             {rawUrl && (
//               <a
//                 href={rawUrl}
//                 target="_blank"
//                 rel="noreferrer"
//                 className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
//                 title="Download"
//               >
//                 <Download className="w-5 h-5" />
//               </a>
//             )}
//             <button
//               onClick={onClose}
//               className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400"
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 bg-gray-100 relative overflow-hidden flex flex-col">
//           <div className="flex-1 relative w-full h-full">
//             {!rawUrl ? (
//               <div className="flex items-center justify-center h-full text-gray-400">
//                 No document URL provided
//               </div>
//             ) : viewer.kind === "excel" ? (
//               <ExcelViewer url={viewer.src} highlightText={highlightText} />
//             ) : viewer.kind === "csv" ? (
//               <CsvViewer url={viewer.src} highlightText={highlightText} />
//             ) : viewer.kind === "docx" ? (
//               <DocxViewer url={viewer.src} highlightText={highlightText} />
//             ) : (
//               <iframe 
//                 src={viewer.src} 
//                 className="w-full h-full border-none bg-white" 
//                 title="Document Viewer" 
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SourceViewModal;
import React, { useEffect, useMemo, useState } from "react";
import { X, ChevronLeft, Download, FileText } from "lucide-react";
import * as XLSX from "xlsx"; 
import Mark from "mark.js"; 
import { renderAsync } from "docx-preview"; 

function getExt(url = "") {
  try {
    const u = new URL(url);
    const path = u.pathname.toLowerCase();
    const m = path.match(/\.([a-z0-9]+)$/);
    return m?.[1] || "";
  } catch {
    const clean = url.split("#")[0].split("?")[0].toLowerCase();
    const m = clean.match(/\.([a-z0-9]+)$/);
    return m?.[1] || "";
  }
}

// Helper: Clean source text from both APIs
function cleanSourceText(rawText) {
  if (!rawText) return "";
  
  return rawText
    // Replace literal "\n" and "\t" strings from JSON with spaces
    .replace(/\\[nt]/g, " ")
    // Replace actual newlines and tabs with spaces
    .replace(/[\n\t]/g, " ")
    // Remove ellipses and markdown/bullet characters including quotes
    .replace(/\.\.\./g, " ")
    .replace(/[•●○■*`#_""'']/g, " ")
    // Replace multiple spaces with single space
    .replace(/\s+/g, " ")
    .trim();
}
  
function buildPdfUrl(rawUrl, { page, highlightText }) {
  let url = rawUrl;
  const fragments = [];
  
  if (page !== undefined && page !== null && page !== "") {
    fragments.push(`page=${page}`);
  }
  
  if (highlightText) {
    // 1. Clean the text thoroughly
    const cleanText = cleanSourceText(highlightText);
    
    // 2. We need a SHORT, EXACT phrase. The native PDF viewer fails on long strings.
    // We split into words, remove tiny words (like "a", "an", "the"), and grab 3-4 words.
    const words = cleanText.split(" ").filter(w => w.length > 3);
    
    let searchTerm = "";
    
    if (words.length >= 4) {
      // Best case: Grab 4 substantial words to form a highly unique fingerprint
      searchTerm = `${words[0]} ${words[1]} ${words[2]} ${words[3]}`;
    } else if (words.length >= 2) {
      // Fallback 1: 2-3 words
      searchTerm = words.slice(0, words.length).join(" ");
    } else if (words.length === 1) {
      // Fallback 2: Single word
      searchTerm = words[0];
    } else {
      // Ultimate fallback: first 25 characters
      searchTerm = cleanText.substring(0, 25);
    }
    
    // 3. Add search parameter. Do NOT use quotes around it for native Chrome/Edge, 
    // it actually prefers URL encoded plain strings for the search parameter.
    if (searchTerm) {
      fragments.push(`search=${encodeURIComponent(searchTerm)}`);
    }
  }

  // PDF parameters MUST be combined with & and preceded by a single #
  if (fragments.length > 0) {
    url += `#${fragments.join("&")}`;
  }
  
  return url;
}
  
// --- DOCX Viewer using docx-preview for High Fidelity ---
function DocxViewer({ url, highlightText }) {
  const [isRendered, setIsRendered] = useState(false);
  const [err, setErr] = useState("");
  const containerRef = React.useRef(null);

  useEffect(() => {
    if (!url || !containerRef.current) return;
    let alive = true;

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.blob(); 
      })
      .then((blob) => {
        if (!alive) return;
        return renderAsync(blob, containerRef.current, null, {
          className: "docx",
          inWrapper: true, 
          ignoreWidth: false,
          ignoreHeight: false,
          ignoreFonts: false,
          breakPages: true, 
          experimental: false,
        });
      })
      .then(() => {
        if (!alive) return;
        setIsRendered(true); 
        setErr("");
      })
      .catch((e) => {
        if (!alive) return;
        setErr(e.message || "Failed to load DOCX");
      });

    return () => {
      alive = false;
    };
  }, [url]);

  useEffect(() => {
    // Clean the highlight text for Mark.js
    const cleanHighlight = cleanSourceText(highlightText);
    if (!isRendered || !cleanHighlight || !containerRef.current) return;

    const markInstance = new Mark(containerRef.current);
    markInstance.mark(cleanHighlight, {
      element: "mark",
      className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900 shadow-sm",
      accuracy: "partially",
      separateWordSearch: false,
      acrossElements: true, 
      done: (totalMatches) => {
        if (totalMatches > 0) {
          setTimeout(() => {
            const firstMark = containerRef.current.querySelector("mark");
            if (firstMark) {
              firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 200);
        }
      }
    });

    return () => markInstance.unmark();
  }, [isRendered, highlightText]);

  if (err) return <div className="p-4 text-sm text-red-600 font-medium">DOCX error: {err}</div>;
  
  return (
    <div className="h-full overflow-auto bg-gray-200 p-4 relative">
      {!isRendered && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
          <span className="text-sm text-gray-500 animate-pulse">Loading Document Layout…</span>
        </div>
      )}
      <div 
        ref={containerRef} 
        className="mx-auto" 
        style={{ width: "fit-content" }}
      />
    </div>
  );
}

// Excel renderer with highlighting and auto-scroll
function ExcelViewer({ url, highlightText }) {
  const [html, setHtml] = useState("");
  const [err, setErr] = useState("");
  const containerRef = React.useRef(null);
  
  useEffect(() => {
    if (!url) return;
    let alive = true;
  
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.arrayBuffer();
      })
      .then((buffer) => {
        if (!alive) return;
        const wb = XLSX.read(buffer, { type: "array" });
        const firstSheet = wb.Sheets[wb.SheetNames[0]];
        const htmlStr = XLSX.utils.sheet_to_html(firstSheet, { header: "", footer: "" });
          
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlStr, "text/html");
        const table = doc.querySelector("table");
          
        if (table) {
          table.className = "w-full text-left border-collapse text-sm font-outfit";
            
          const rows = table.querySelectorAll("tr");
          rows.forEach((tr, index) => {
            tr.className = "border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150 ease-in-out group";
            if (index === 0) tr.classList.add("bg-gray-50", "font-medium", "text-gray-900");
          });
  
          const cells = table.querySelectorAll("td, th");
          cells.forEach((td) => {
            td.className = "px-4 py-3 border-r border-gray-200 last:border-r-0 text-gray-700 whitespace-pre-wrap break-words align-top leading-relaxed tracking-wide";
            if (!td.textContent.trim()) td.innerHTML = "&nbsp;";
          });
  
          setHtml(table.outerHTML);
        } else {
          setHtml(htmlStr);
        }
        setErr("");
      })
      .catch((e) => {
        if (!alive) return;
        setErr(e.message || "Failed to load Excel");
      });
  
    return () => {
      alive = false;
    };
  }, [url]);
  
  useEffect(() => {
    const cleanHighlight = cleanSourceText(highlightText);
    if (!html || !cleanHighlight || !containerRef.current) return;
  
    const markInstance = new Mark(containerRef.current);
    markInstance.mark(cleanHighlight, {
      element: "mark",
      className: "bg-yellow-300 rounded-sm px-0.5 text-gray-900",
      accuracy: "partially",
      separateWordSearch: false,
      done: (totalMatches) => {
        if (totalMatches > 0) {
          setTimeout(() => {
            const firstMark = containerRef.current.querySelector("mark");
            if (firstMark) {
              firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 100);
        }
      }
    });
  
    return () => markInstance.unmark();
  }, [html, highlightText]);
  
  if (err) return <div className="p-4 text-sm text-red-600 font-medium">Excel error: {err}</div>;
  if (!html) return <div className="p-4 text-sm text-gray-500 animate-pulse">Loading Excel…</div>;
  
  return (
    <div
      ref={containerRef}
      className="p-6 h-full overflow-auto bg-white"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
  
// CSV renderer with highlighting
function CsvViewer({ url, highlightText }) {
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const containerRef = React.useRef(null);

  useEffect(() => {
    if (!url) return;
    let alive = true;

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((t) => {
        if (!alive) return;
        setText(t);
        setErr("");
      })
      .catch((e) => {
        if (!alive) return;
        setErr(e.message || "Failed to load CSV");
      });

    return () => {
      alive = false;
    };
  }, [url]);

  useEffect(() => {
    const cleanHighlight = cleanSourceText(highlightText);
    if (!text || !cleanHighlight || !containerRef.current) return;

    const markInstance = new Mark(containerRef.current);
    markInstance.mark(cleanHighlight, {
      element: "mark",
      className: "bg-yellow-300",
      accuracy: "partially",
      separateWordSearch: false,
    });

    return () => markInstance.unmark();
  }, [text, highlightText]);

  if (err) return <div className="p-4 text-sm text-red-600">CSV error: {err}</div>;
  if (!text) return <div className="p-4 text-sm text-gray-500">Loading CSV…</div>;

  return (
    <div ref={containerRef} className="p-3 h-full overflow-auto bg-white">
      <pre className="text-xs whitespace-pre-wrap break-words text-gray-800">{text}</pre>
    </div>
  );
}

function buildViewer({ url, ext, page, highlightText }) {
  if (!url) return { kind: "none", src: "" };

  if (ext === "pdf") {
    return { kind: "iframe", src: buildPdfUrl(url, { page, highlightText }) };
  }

  if (["xls", "xlsx"].includes(ext)) {
    return { kind: "excel", src: url };
  }

  if (ext === "csv") {
    return { kind: "csv", src: url };
  }

  if (ext === "docx") {
    return { kind: "docx", src: url };
  }

  if (["doc", "ppt", "pptx"].includes(ext)) {
    const officeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      url
    )}`;
    return { kind: "iframe", src: officeSrc };
  }

  return { kind: "iframe", src: url };
}

// Helper to format the displayed text cleanly in the UI card
function cleanSnippetForDisplay(rawText) {
  if (!rawText) return "";
  return rawText
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, " ")
    .replace(/\.\.\./g, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .trim();
}

const SourceViewModal = ({ isOpen, onClose, data }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = "hidden";
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      document.body.style.overflow = "unset";
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const rawUrl = data?.document_url || data?.file_url || data?.url || "";
  const ext = useMemo(() => getExt(rawUrl), [rawUrl]);
  
  // FIXED: Prioritize highlightText passed explicitly from ProposalPage's format, 
  // then fallback to raw chunks/snippets.
  const highlightText = data?.highlightText || data?.source_chunk || data?.source_text || data?.snippet || "";
  
  // Explicit check for undefined vs 0
  const pageNum = data?.page_number !== undefined ? data.page_number : (data?.page !== undefined ? data.page : "");
  const docName = data?.document_name || data?.file_name || data?.name || "Document Viewer";

  const viewer = useMemo(
    () =>
      buildViewer({
        url: rawUrl,
        ext,
        page: pageNum,
        highlightText: highlightText,
      }),
    [rawUrl, ext, pageNum, highlightText]
  );

  if (!isVisible && !isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex justify-end font-outfit">
      <div
        className={`absolute inset-0 bg-black/30 transition-opacity duration-300 ease-in-out ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />

      <div
        className={`relative w-full lg:w-[55%] h-full bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white shadow-sm z-20 relative">
          <div className="flex items-center gap-3 overflow-hidden">
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            <div className="flex flex-col overflow-hidden">
              <h3 className="text-sm font-semibold text-gray-900 truncate" title={docName}>
                {docName}
              </h3>
              <span className="text-xs text-gray-500">
                {ext ? ext.toUpperCase() : "FILE"}
                {pageNum !== "" && pageNum !== null && pageNum !== undefined ? ` • Page ${pageNum}` : ""}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {rawUrl && (
              <a
                href={rawUrl}
                target="_blank"
                rel="noreferrer"
                className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
                title="Download"
              >
                <Download className="w-5 h-5" />
              </a>
            )}
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="flex-1 bg-gray-100 relative overflow-hidden flex flex-col">
          <div className="flex-1 relative w-full h-full">
            {!rawUrl ? (
              <div className="flex items-center justify-center h-full text-gray-400">
                No document URL provided
              </div>
            ) : viewer.kind === "excel" ? (
              <ExcelViewer url={viewer.src} highlightText={highlightText} />
            ) : viewer.kind === "csv" ? (
              <CsvViewer url={viewer.src} highlightText={highlightText} />
            ) : viewer.kind === "docx" ? (
              <DocxViewer url={viewer.src} highlightText={highlightText} />
            ) : (
              <iframe 
                src={viewer.src} 
                className="w-full h-full border-none bg-white" 
                title="Document Viewer" 
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceViewModal;
